import React, { useCallback, useEffect, useMemo, useState } from "react";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";
import customer_table1 from "../../../assets/images/admin/customer_table1.svg";
import { apiUrl } from "../../../config/Config";
import PostPreviewModal from "../../common/PostPreviewModal";

ModuleRegistry.registerModules([ClientSideRowModelModule]);

const UserDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userdata = useSelector((store) => store.userReducer.userdata);
  const [selectedTab, setSelectedTab] = useState("posts");
  const [details, setDetails] = useState(null);
  const [selectedPost, setSelectedPost] = useState(null);
  const [showloding, setshowloding] = useState(false);
  const paginationPageSizeSelector = useMemo(() => [10, 20, 50, 100], []);

  const headers = useMemo(() => ({
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + userdata?.token,
    },
  }), [userdata?.token]);

  const handleInvalidUser = useCallback((message) => {
    if (message === "invalid user") {
      dispatch({ type: "userdata", payload: {} });
      navigate("/admin/login");
      return true;
    }
    return false;
  }, [dispatch, navigate]);

  const fetchDetails = useCallback(async () => {
    setshowloding(true);
    await axios
      .post(apiUrl + "admingetuserdetails", { id }, headers)
      .then((res) => {
        if (res.data.status === "success") {
          setDetails(res.data.data);
        } else if (!handleInvalidUser(res.data.message)) {
          alert(res.data.message);
        }
      })
      .catch((err) => alert(err.message));
    setshowloding(false);
  }, [handleInvalidUser, headers, id]);

  useEffect(() => {
    fetchDetails();
  }, [fetchDetails]);

  const user = details?.user || {};
  const summary = details?.summary || {};

  const formatDate = (value) => value ? moment(value).format("DD MMM YYYY, hh:mm A") : "-";

  const dataByTab = {
    posts: details?.posts || [],
    blocked: details?.blocked || [],
    blocked_by: details?.blocked_by || [],
    reports: details?.reports || [],
    reported_by_user: details?.reported_by_user || [],
  };

  const columnsByTab = {
    posts: [
      { field: "biotext", headerName: "Post", minWidth: 280 },
      { field: "city", headerName: "City", minWidth: 140 },
      { field: "state", headerName: "State", minWidth: 140 },
      { field: "visibility", headerName: "Visibility", minWidth: 130 },
      { field: "created_at", headerName: "Date", minWidth: 180, cellRenderer: (props) => formatDate(props.data.created_at) },
      {
        field: "action",
        headerName: "Action",
        minWidth: 90,
        cellRenderer: (props) => (
          <div className="admin-grid-actions">
            <button title="View post" onClick={() => setSelectedPost(props.data)}>
              <FontAwesomeIcon icon={faEye} />
            </button>
          </div>
        ),
      },
    ],
    blocked: [
      { field: "fullname", headerName: "Blocked User", minWidth: 200 },
      { field: "email", headerName: "Email", minWidth: 220 },
      { field: "created_at", headerName: "Date", minWidth: 180, cellRenderer: (props) => formatDate(props.data.created_at) },
    ],
    blocked_by: [
      { field: "fullname", headerName: "Blocked By", minWidth: 200 },
      { field: "email", headerName: "Email", minWidth: 220 },
      { field: "created_at", headerName: "Date", minWidth: 180, cellRenderer: (props) => formatDate(props.data.created_at) },
    ],
    reports: [
      { field: "reporter_name", headerName: "Reported By", minWidth: 200 },
      { field: "content_type", headerName: "Type", minWidth: 120 },
      { field: "reason", headerName: "Reason", minWidth: 260 },
      { field: "status", headerName: "Status", minWidth: 130 },
      { field: "created_at", headerName: "Date", minWidth: 180, cellRenderer: (props) => formatDate(props.data.created_at) },
    ],
    reported_by_user: [
      { field: "reported_user_name", headerName: "Reported User", minWidth: 200 },
      { field: "content_type", headerName: "Type", minWidth: 120 },
      { field: "reason", headerName: "Reason", minWidth: 260 },
      { field: "status", headerName: "Status", minWidth: 130 },
      { field: "created_at", headerName: "Date", minWidth: 180, cellRenderer: (props) => formatDate(props.data.created_at) },
    ],
  };

  return (
    <div className="dashboardbox" style={{ width: "100%" }}>
      <div className="customerdetailsrow row">
        <div className="col-md-4">
          <div className="customerdetailsbox">
            <div className="customerdetailsnamediv">
              <img src={customer_table1} className="customerdetailsicon" alt="" />
              <div className="customerdetailsnamerightdiv">
                <p className="customerdetailsnamerightdiv_name">{user.fullname || "-"}</p>
                <p className="customerdetailsnamerightdiv_email">{user.mobile || user.email || "-"}</p>
              </div>
            </div>
            <div className="admin-user-summary-grid">
              <div><p>{summary.posts_count || 0}</p><span>Posts</span></div>
              <div><p>{summary.connections_count || 0}</p><span>Connections</span></div>
              <div><p>{summary.reports_count || 0}</p><span>Reports</span></div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="customerdetailsbox">
            <p className="personal-info-title">PERSONAL INFORMATION</p>
            <div className="personal-info-row"><p className="personal-info-key">Email</p><p className="personal-info-value">{user.email || "-"}</p></div>
            <div className="personal-info-row"><p className="personal-info-key">Designation</p><p className="personal-info-value">{user.designation || "-"}</p></div>
            <div className="personal-info-row"><p className="personal-info-key">Status</p><p className="personal-info-value">{user.status || "Active"}</p></div>
            <div className="personal-info-row"><p className="personal-info-key">Joined</p><p className="personal-info-value">{user.created_at ? moment(user.created_at).format("DD MMM YYYY") : "-"}</p></div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="customerdetailsbox">
            <p className="personal-info-title">LOCATION</p>
            <div className="personal-info-row"><p className="personal-info-key">City</p><p className="personal-info-value">{user.city || "-"}</p></div>
            <div className="personal-info-row"><p className="personal-info-key">State</p><p className="personal-info-value">{user.state || "-"}</p></div>
            <div className="personal-info-row"><p className="personal-info-key">Privacy</p><p className="personal-info-value">{user.account_privacy || "-"}</p></div>
          </div>
        </div>
      </div>

      <div className="productstogglebar mt-5">
        <div className="orderstatustogglediv">
          {[
            ["posts", "Posts"],
            ["blocked", "Blocked"],
            ["blocked_by", "Blocked By"],
            ["reports", "Reported"],
            ["reported_by_user", "Reported By User"],
          ].map(([key, label]) => (
            <div key={key} className={selectedTab === key ? "orderstatusdiv active" : "orderstatusdiv"} onClick={() => setSelectedTab(key)}>
              <p>{label}</p>
            </div>
          ))}
        </div>
        {showloding ? <div className="moderation-loader"><Spinner color="#34A853" size={18} /></div> : null}
      </div>

      <div className="ag-theme-quartz mt-4" style={{ width: "100%", height: 520 }}>
        <AgGridReact
          rowData={dataByTab[selectedTab]}
          columnDefs={columnsByTab[selectedTab]}
          defaultColDef={{ flex: 1, filter: true, sortable: true, resizable: true }}
          pagination={true}
          paginationPageSize={10}
          paginationPageSizeSelector={paginationPageSizeSelector}
          rowHeight={54}
        />
      </div>
      <PostPreviewModal post={selectedPost} onClose={() => setSelectedPost(null)} />
    </div>
  );
};

export default UserDetails;
